"use client"

import { useQuery } from "@tanstack/react-query"
import {
  listOutgoingVoiceCallPhoneNumbersAction,
} from "@/server-actions/outgoing-voice-calls"
import type { OutgoingPhoneNumber } from "@/lib/voice/outgoing-calls"

export const outgoingVoiceCallPhoneNumbersQueryKey = ["outgoing-voice-call-phone-numbers"] as const

export function useOutgoingVoiceCallPhoneNumbersQuery(enabled = true) {
  return useQuery<OutgoingPhoneNumber[]>({
    queryKey: outgoingVoiceCallPhoneNumbersQueryKey,
    enabled,
    queryFn: async () => {
      const result = await listOutgoingVoiceCallPhoneNumbersAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
